import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalOptions } from '@shared/models';
import { ModalService } from '@shared/services';

export type SaveSearchModalResponse = {
  searchName: string;
};

@Component({
  selector: 'lib-save-search-modal',
  templateUrl: 'save-search-modal.component.html',
  imports: [ReactiveFormsModule, FormsModule],
})
export class SaveSearchModalComponent implements OnInit {
  private readonly modalService = inject(ModalService);
  public options: ModalOptions | undefined;

  public ngOnInit() {
    this.options = this.modalService.options;
  }

  public form = new FormGroup({
    searchName: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.maxLength(50)] }),
  });

  public get title() {
    return this.options?.data?.openedAutomatically ? 'Unsaved search' : 'Save search';
  }

  public get isSaveDisabled() {
    if (!this.form) {
      return true;
    }
    return this.form.invalid || !this.form.dirty;
  }

  public onSubmit() {
    if (this.form.invalid) {
      return;
    }

    this.modalService.close(this.form.getRawValue());
  }

  public onDontSave() {
    this.modalService.close();
  }

  public onCancel() {
    this.modalService.dismiss();
  }
}
